import React from 'react';
import { FormControl, Select, MenuItem, FormHelperText } from '@mui/material';

const SelectInput = ({
    name,
    value,
    onChange,
    onBlur,
    error,
    touched,
    options = [],
    placeholder = 'Select an option',
    disabled = false,
    size = 'medium',
}) => {
    const hasError = Boolean(touched && error);
    const isEmpty = value === '' || value == null;

    return (
        <FormControl fullWidth error={hasError} disabled={disabled}>

            <Select
                name={name}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
                displayEmpty={true}        r
                size={size}
                MenuProps={{ PaperProps: { sx: { mt: 0.5 } } }}
            >
                <MenuItem value="" disabled>
                    <em>{placeholder}</em>
                </MenuItem>

                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>

            {hasError && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};

export default SelectInput;

export const BillingCycleOptions = [
    { value: 'Every Month', label: 'Every Month' },
    { value: 'Every Six Month', label: 'Every Six Month' },
    { value: 'Every Year', label: 'Every Year' },
    { value: 'Every Two Years', label: 'Every Two Years' },
    { value: 'Every Three Years', label: 'Every Three Years' },
    { value: 'Every Four Years', label: 'Every Four Years' },
    { value: 'Every Five Years', label: 'Every Five Years' },
];

export const ServiceStatusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Expired', label: 'Expired' },
    { value: 'Pending', label: 'Pending' },
];


export const ServiceTypeOptions = [
    { value: 'Domain', label: 'Domain' },
    { value: 'Hosting', label: 'Hosting' },
    { value: 'Domain & Hosting', label: 'Domain & Hosting' },
];

